import React, { Component, Fragment } from 'react'
import { Link } from "react-router-dom"

import logo_black from 'static/images/icons/cellwine-logo-black.svg'

class Footer extends Component {
	render() {
		return (
			<Fragment>
				<footer className="pt-5 pl-5 pr-5">
					<div className="container">
						<div className="row">
							<div className="col-sm-4 order-sm-1">
								<img className="" src={logo_black} alt="" />
								<br />
								<div className="footer-item">
									<a href="https://cell.wine" target="_blank">CELLWINE 官網</a>
								</div>
							</div>
							<div className="col-sm-8 order-sm-2">
								<div className="row">
									<div className="col-md-5">
										<div className="footer-item">
											<Link to="faq">常見問題</Link>
											<br />
											<Link to="price-detail">收費標準</Link>
											<br />
											<Link to="terms-of-use">條款及細則</Link>
										</div>

									</div>
									<div className="col-md-7">
										<div className="footer-item">
											<b>聯絡電話</b>
											<br />
											02-23222885
											<br />
											<b>電子信箱</b>
											<br />
											<a href="mainto:service@cell.wine">service@cell.wine</a>
										</div>

									</div>
								</div>
								<div className="row">
									<div className="col-md-5">
										<div className="footer-item">
											<b>服務時間</b>
											<br />
											週二～週六 10:00-20:00
											<br />
											*國定假日休息
										</div>

									</div>
									<div className="col-md-7">
										<div className="footer-item">
											<b>總公司</b>
											<br />
											台北市大安區新生南路二段2號B1
										</div>
									</div>
									<div className="col-md-7">
										<div className="footer-item">
											<b>若堤科技股份有限公司</b>
											<br />
											統一編號：83199442
										</div>
									</div>
								</div>
							</div>
						</div>

					</div>
					<hr className=" mb-0 mt-5" />
				</footer>
				<div className="container-fluid" style={{ backgroundColor: 'white' }}>
					<div className="row">
						<div className="col-12 text-center">
							<p style={{
								fontSize: '16px',
								color: 'rgba(0, 0, 0, 0.65)',
								marginTop: '10px'
							}}>©2018 CELLWINE. All rights reserved.</p>
						</div>
					</div>
				</div>
			</Fragment>
		)
	}
}

export default Footer
